import { defineStore } from "pinia";
import { ref } from "vue";

export const useNotificacaoStore = defineStore("notificacao", () => {
  const isOpen = ref(false);
  const mensagem = ref("");
  const titulo = ref("");
  const isSuccess = ref(true); // true = sucesso, false = erro

  function showSucesso(msg?: string) {
    isOpen.value = true;
    isSuccess.value = true;

    titulo.value = "Sucesso!";
    mensagem.value = msg ?? "Email enviado com sucesso!";
  }

  function showErro(msg?: string) {
    isOpen.value = true;
    isSuccess.value = false;

    titulo.value = "Tente novamente!";
    mensagem.value = msg ?? "Falha ao enviar email, tente novamente.";
  }

  function close() {
    isOpen.value = false;
  }

  return {
    isOpen,
    titulo,
    mensagem,
    isSuccess,
    showSucesso,
    showErro,
    close,
  };
});
